export default "__VITE_ASSET__1f5e0cfe__"